// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Mulish:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── TOKENS ───────────────────────────────────────────── */
:root {
  --vnd-bg:          #F7F7F5;
  --vnd-surface:     #FFFFFF;
  --vnd-border:      #E8E8E4;
  --vnd-ink:         #1A1A18;
  --vnd-ink-2:       #5A5A56;
  --vnd-ink-3:       #9A9A96;
  --vnd-accent:      #14b8a6;
  --vnd-accent-lt:   #EEF2F7;
  --vnd-gold:        #C6973F;
  --vnd-green:       #2E7D52;
  --vnd-green-lt:    #EAF4EE;
  --vnd-red:         #B03A2E;
  --vnd-red-lt:      #FDECEA;
  --vnd-radius:      10px;
  --vnd-shadow:      0 2px 12px rgba(0,0,0,.07);
  --vnd-shadow-md:   0 4px 24px rgba(0,0,0,.10);
  font-family: 'Mulish', sans-serif;
}

/* ── PAGE ─────────────────────────────────────────────── */
.vnd-page {
  background: var(--vnd-bg);
  min-height: 100vh;
  padding: 32px 36px 48px;
  max-width: 1100px;
  margin: 0 auto;
}

/* ── HERO ─────────────────────────────────────────────── */
.vnd-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
  flex-wrap: wrap;
}

.vnd-hero-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.vnd-hero-icon {
  width: 52px;
  height: 52px;
  background: var(--vnd-accent);
  color: #fff;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(28,53,87,.25);
}

.vnd-title {
  /* font-family: 'Playfair Display', serif; */
  font-size: 26px;
  color: var(--vnd-ink);
  margin: 0 0 2px;
  letter-spacing: -.3px;
}

.vnd-subtitle {
  font-size: 13px;
  color: var(--vnd-ink-3);
  margin: 0;
  font-weight: 500;
}

.vnd-hero-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── BUTTONS ──────────────────────────────────────────── */
.vnd-btn-primary {
  background: var(--vnd-accent);
  color: #fff;
  border: none;
  padding: 9px 20px;
  border-radius: 8px;
  font-family: 'Mulish', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  letter-spacing: .2px;
  transition: background .18s, transform .12s, box-shadow .18s;
  box-shadow: 0 2px 8px rgba(28,53,87,.2);
}
.vnd-btn-primary:hover {
  background: #142A45;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(28,53,87,.28);
}
.vnd-btn-primary:active { transform: translateY(0); }

.vnd-btn-outline {
  background: var(--vnd-surface);
  color: var(--vnd-accent);
  border: 1.5px solid var(--vnd-accent);
  padding: 8px 18px;
  border-radius: 8px;
  font-family: 'Mulish', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background .18s, transform .12s;
}
.vnd-btn-outline:hover {
  background: var(--vnd-accent-lt);
  transform: translateY(-1px);
}

/* ── STATS ────────────────────────────────────────────── */
.vnd-stats {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: var(--vnd-surface);
  border: 1px solid var(--vnd-border);
  border-radius: var(--vnd-radius);
  padding: 14px 24px;
  margin-bottom: 24px;
  box-shadow: var(--vnd-shadow);
}

.vnd-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 0 24px;
}
.vnd-stat:first-child { padding-left: 0; }

.vnd-stat-val {
  font-family: 'Playfair Display', serif;
  font-size: 24px;
  color: var(--vnd-accent);
  line-height: 1;
}

.vnd-stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--vnd-ink-3);
  font-weight: 700;
}

.vnd-stat-divider {
  width: 1px;
  height: 36px;
  background: var(--vnd-border);
}

/* ── SEARCH ───────────────────────────────────────────── */
.vnd-search-row {
  margin-bottom: 20px;
}

.vnd-search-box {
  position: relative;
  max-width: 480px;
}

.vnd-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--vnd-ink-3);
  font-size: 13px;
  pointer-events: none;
}

.vnd-search-input {
  width: 100%;
  padding: 10px 40px 10px 38px;
  background: var(--vnd-surface);
  border: 1.5px solid var(--vnd-border);
  border-radius: 8px;
  font-family: 'Mulish', sans-serif;
  font-size: 13.5px;
  color: var(--vnd-ink);
  outline: none;
  transition: border-color .18s, box-shadow .18s;
}
.vnd-search-input::placeholder { color: var(--vnd-ink-3); }
.vnd-search-input:focus {
  border-color: var(--vnd-accent);
  box-shadow: 0 0 0 3px rgba(28,53,87,.1);
}

.vnd-search-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--vnd-ink-3);
  cursor: pointer;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
  transition: color .15s;
}
.vnd-search-clear:hover { color: var(--vnd-red); }

/* ── TABLE CARD ───────────────────────────────────────── */
.vnd-table-card {
  background: var(--vnd-surface);
  border: 1px solid var(--vnd-border);
  border-radius: 12px;
  box-shadow: var(--vnd-shadow-md);
  overflow: hidden;
}

/* ── STATE (loading / empty) ──────────────────────────── */
.vnd-state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 24px;
  color: var(--vnd-ink-3);
  font-size: 14px;
  gap: 6px;
}
.vnd-state-box small { font-size: 12px; }

.vnd-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--vnd-border);
  border-top-color: var(--vnd-accent);
  border-radius: 50%;
  animation: vnd-spin .75s linear infinite;
  margin-bottom: 12px;
}
@keyframes vnd-spin { to { transform: rotate(360deg); } }

/* ── TABLE ────────────────────────────────────────────── */
.vnd-table {
  width: 100%;
  border-collapse: collapse;
}

.vnd-table thead {
  background: #F2F2EF;
}

.vnd-table th {
  padding: 13px 20px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: var(--vnd-ink-3);
  text-align: left;
  border-bottom: 1px solid var(--vnd-border);
}

.vnd-table tbody tr {
  border-bottom: 1px solid var(--vnd-border);
  animation: vnd-row-in .3s ease both;
  transition: background .14s;
}
.vnd-table tbody tr:last-child { border-bottom: none; }
.vnd-table tbody tr:hover { background: #FAFAF8; }

@keyframes vnd-row-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.vnd-table td {
  padding: 14px 20px;
  font-size: 13.5px;
  color: var(--vnd-ink);
  vertical-align: middle;
}

/* index col */
.vnd-idx {
  font-size: 12px;
  color: var(--vnd-ink-3);
  font-weight: 700;
  width: 44px;
}

/* ── VENDOR NAME CELL ─────────────────────────────────── */
.vnd-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vnd-avatar {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  letter-spacing: .5px;
}

.vnd-name-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vnd-name {
  font-weight: 700;
  color: var(--vnd-ink);
  font-size: 14px;
}

.vnd-id-tag {
  font-size: 11px;
  color: var(--vnd-ink-3);
  font-weight: 500;
}

/* ── PHONE ────────────────────────────────────────────── */
.vnd-phone {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--vnd-accent-lt);
  color: var(--vnd-ink);
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.vnd-phone-icon {
  font-size: 10px;
  opacity: .7;
}

/* ── ACTION BUTTONS ───────────────────────────────────── */
.vnd-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vnd-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 13px;
  border-radius: 7px;
  font-family: 'Mulish', sans-serif;
  font-size: 12px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: transform .12s, box-shadow .15s, filter .15s;
  letter-spacing: .2px;
}
.vnd-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0,0,0,.12);
}
.vnd-action-btn:active { transform: translateY(0); }

.vnd-btn-view {
  background: var(--vnd-accent-lt);
  color: var(--vnd-ink);
}
.vnd-btn-view:hover { background: #dce7f3; }

.vnd-btn-edit {
  background: #FFF8EC;
  color: var(--vnd-gold);
}
.vnd-btn-edit:hover { background: #fef0d2; }

.vnd-btn-delete {
  background: var(--vnd-red-lt);
  color: var(--vnd-red);
  padding: 6px 10px;
}
.vnd-btn-delete:hover { background: #fbd9d6; }

/* ── FOOTER NOTE ──────────────────────────────────────── */
.vnd-footer-note {
  font-size: 12px;
  color: var(--vnd-ink-3);
  text-align: right;
  margin-top: 14px;
  font-weight: 500;
}

/* ── RESPONSIVE ───────────────────────────────────────── */
@media (max-width: 640px) {
  .vnd-page { padding: 20px 16px 40px; }
  .vnd-hero { flex-direction: column; align-items: flex-start; }
  .vnd-stats { flex-direction: column; width: 100%; }
  .vnd-stat-divider { width: 100%; height: 1px; }
  .vnd-table th:nth-child(1),
  .vnd-table td:nth-child(1) { display: none; }
  .vnd-action-btn span { display: none; }
  .vnd-action-btn { padding: 7px 9px; }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Material/Vender.css"],"names":[],"mappings":"AAEA,4DAA4D;AAC5D;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,6CAA6C;EAC7C,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,4DAA4D;EAC5D,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA,0BAA0B,wBAAwB,EAAE;;AAEpD;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA,wBAAwB,eAAe,EAAE;;AAEzC;EACE,sCAAsC;EACtC,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;AACA,iCAAiC,uBAAuB,EAAE;AAC1D;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,0BAA0B,qBAAqB,EAAE;;AAEjD,4DAA4D;AAC5D;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;AACA,uBAAuB,eAAe,EAAE;;AAExC;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD,4DAA4D;AAC5D;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,2BAA2B;AAC7B;AACA,iCAAiC,mBAAmB,EAAE;AACtD,4BAA4B,mBAAmB,EAAE;;AAEjD;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wDAAwD;EACxD,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;AACA,yBAAyB,wBAAwB,EAAE;;AAEnD;EACE,gCAAgC;EAChC,qBAAqB;AACvB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,4DAA4D;AAC5D;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,YAAY,uBAAuB,EAAE;EACrC,YAAY,sBAAsB,EAAE,uBAAuB,EAAE;EAC7D,aAAa,sBAAsB,EAAE,WAAW,EAAE;EAClD,oBAAoB,WAAW,EAAE,WAAW,EAAE;EAC9C;+BAC6B,aAAa,EAAE;EAC5C,uBAAuB,aAAa,EAAE;EACtC,kBAAkB,gBAAgB,EAAE;AACtC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Mulish:wght@400;500;600;700&display=swap');\n\n/* ── TOKENS ───────────────────────────────────────────── */\n:root {\n  --vnd-bg:          #F7F7F5;\n  --vnd-surface:     #FFFFFF;\n  --vnd-border:      #E8E8E4;\n  --vnd-ink:         #1A1A18;\n  --vnd-ink-2:       #5A5A56;\n  --vnd-ink-3:       #9A9A96;\n  --vnd-accent:      #14b8a6;\n  --vnd-accent-lt:   #EEF2F7;\n  --vnd-gold:        #C6973F;\n  --vnd-green:       #2E7D52;\n  --vnd-green-lt:    #EAF4EE;\n  --vnd-red:         #B03A2E;\n  --vnd-red-lt:      #FDECEA;\n  --vnd-radius:      10px;\n  --vnd-shadow:      0 2px 12px rgba(0,0,0,.07);\n  --vnd-shadow-md:   0 4px 24px rgba(0,0,0,.10);\n  font-family: 'Mulish', sans-serif;\n}\n\n/* ── PAGE ─────────────────────────────────────────────── */\n.vnd-page {\n  background: var(--vnd-bg);\n  min-height: 100vh;\n  padding: 32px 36px 48px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n/* ── HERO ─────────────────────────────────────────────── */\n.vnd-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.vnd-hero-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.vnd-hero-icon {\n  width: 52px;\n  height: 52px;\n  background: var(--vnd-accent);\n  color: #fff;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  font-size: 20px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(28,53,87,.25);\n}\n\n.vnd-title {\n  /* font-family: 'Playfair Display', serif; */\n  font-size: 26px;\n  color: var(--vnd-ink);\n  margin: 0 0 2px;\n  letter-spacing: -.3px;\n}\n\n.vnd-subtitle {\n  font-size: 13px;\n  color: var(--vnd-ink-3);\n  margin: 0;\n  font-weight: 500;\n}\n\n.vnd-hero-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ── BUTTONS ──────────────────────────────────────────── */\n.vnd-btn-primary {\n  background: var(--vnd-accent);\n  color: #fff;\n  border: none;\n  padding: 9px 20px;\n  border-radius: 8px;\n  font-family: 'Mulish', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  letter-spacing: .2px;\n  transition: background .18s, transform .12s, box-shadow .18s;\n  box-shadow: 0 2px 8px rgba(28,53,87,.2);\n}\n.vnd-btn-primary:hover {\n  background: #142A45;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(28,53,87,.28);\n}\n.vnd-btn-primary:active { transform: translateY(0); }\n\n.vnd-btn-outline {\n  background: var(--vnd-surface);\n  color: var(--vnd-accent);\n  border: 1.5px solid var(--vnd-accent);\n  padding: 8px 18px;\n  border-radius: 8px;\n  font-family: 'Mulish', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background .18s, transform .12s;\n}\n.vnd-btn-outline:hover {\n  background: var(--vnd-accent-lt);\n  transform: translateY(-1px);\n}\n\n/* ── STATS ────────────────────────────────────────────── */\n.vnd-stats {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  background: var(--vnd-surface);\n  border: 1px solid var(--vnd-border);\n  border-radius: var(--vnd-radius);\n  padding: 14px 24px;\n  margin-bottom: 24px;\n  box-shadow: var(--vnd-shadow);\n}\n\n.vnd-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 0 24px;\n}\n.vnd-stat:first-child { padding-left: 0; }\n\n.vnd-stat-val {\n  font-family: 'Playfair Display', serif;\n  font-size: 24px;\n  color: var(--vnd-accent);\n  line-height: 1;\n}\n\n.vnd-stat-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  color: var(--vnd-ink-3);\n  font-weight: 700;\n}\n\n.vnd-stat-divider {\n  width: 1px;\n  height: 36px;\n  background: var(--vnd-border);\n}\n\n/* ── SEARCH ───────────────────────────────────────────── */\n.vnd-search-row {\n  margin-bottom: 20px;\n}\n\n.vnd-search-box {\n  position: relative;\n  max-width: 480px;\n}\n\n.vnd-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--vnd-ink-3);\n  font-size: 13px;\n  pointer-events: none;\n}\n\n.vnd-search-input {\n  width: 100%;\n  padding: 10px 40px 10px 38px;\n  background: var(--vnd-surface);\n  border: 1.5px solid var(--vnd-border);\n  border-radius: 8px;\n  font-family: 'Mulish', sans-serif;\n  font-size: 13.5px;\n  color: var(--vnd-ink);\n  outline: none;\n  transition: border-color .18s, box-shadow .18s;\n}\n.vnd-search-input::placeholder { color: var(--vnd-ink-3); }\n.vnd-search-input:focus {\n  border-color: var(--vnd-accent);\n  box-shadow: 0 0 0 3px rgba(28,53,87,.1);\n}\n\n.vnd-search-clear {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--vnd-ink-3);\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: color .15s;\n}\n.vnd-search-clear:hover { color: var(--vnd-red); }\n\n/* ── TABLE CARD ───────────────────────────────────────── */\n.vnd-table-card {\n  background: var(--vnd-surface);\n  border: 1px solid var(--vnd-border);\n  border-radius: 12px;\n  box-shadow: var(--vnd-shadow-md);\n  overflow: hidden;\n}\n\n/* ── STATE (loading / empty) ──────────────────────────── */\n.vnd-state-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 72px 24px;\n  color: var(--vnd-ink-3);\n  font-size: 14px;\n  gap: 6px;\n}\n.vnd-state-box small { font-size: 12px; }\n\n.vnd-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--vnd-border);\n  border-top-color: var(--vnd-accent);\n  border-radius: 50%;\n  animation: vnd-spin .75s linear infinite;\n  margin-bottom: 12px;\n}\n@keyframes vnd-spin { to { transform: rotate(360deg); } }\n\n/* ── TABLE ────────────────────────────────────────────── */\n.vnd-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.vnd-table thead {\n  background: #F2F2EF;\n}\n\n.vnd-table th {\n  padding: 13px 20px;\n  font-size: 10.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.4px;\n  color: var(--vnd-ink-3);\n  text-align: left;\n  border-bottom: 1px solid var(--vnd-border);\n}\n\n.vnd-table tbody tr {\n  border-bottom: 1px solid var(--vnd-border);\n  animation: vnd-row-in .3s ease both;\n  transition: background .14s;\n}\n.vnd-table tbody tr:last-child { border-bottom: none; }\n.vnd-table tbody tr:hover { background: #FAFAF8; }\n\n@keyframes vnd-row-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.vnd-table td {\n  padding: 14px 20px;\n  font-size: 13.5px;\n  color: var(--vnd-ink);\n  vertical-align: middle;\n}\n\n/* index col */\n.vnd-idx {\n  font-size: 12px;\n  color: var(--vnd-ink-3);\n  font-weight: 700;\n  width: 44px;\n}\n\n/* ── VENDOR NAME CELL ─────────────────────────────────── */\n.vnd-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.vnd-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  letter-spacing: .5px;\n}\n\n.vnd-name-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.vnd-name {\n  font-weight: 700;\n  color: var(--vnd-ink);\n  font-size: 14px;\n}\n\n.vnd-id-tag {\n  font-size: 11px;\n  color: var(--vnd-ink-3);\n  font-weight: 500;\n}\n\n/* ── PHONE ────────────────────────────────────────────── */\n.vnd-phone {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: var(--vnd-accent-lt);\n  color: var(--vnd-ink);\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.vnd-phone-icon {\n  font-size: 10px;\n  opacity: .7;\n}\n\n/* ── ACTION BUTTONS ───────────────────────────────────── */\n.vnd-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.vnd-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 13px;\n  border-radius: 7px;\n  font-family: 'Mulish', sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: transform .12s, box-shadow .15s, filter .15s;\n  letter-spacing: .2px;\n}\n.vnd-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 10px rgba(0,0,0,.12);\n}\n.vnd-action-btn:active { transform: translateY(0); }\n\n.vnd-btn-view {\n  background: var(--vnd-accent-lt);\n  color: var(--vnd-ink);\n}\n.vnd-btn-view:hover { background: #dce7f3; }\n\n.vnd-btn-edit {\n  background: #FFF8EC;\n  color: var(--vnd-gold);\n}\n.vnd-btn-edit:hover { background: #fef0d2; }\n\n.vnd-btn-delete {\n  background: var(--vnd-red-lt);\n  color: var(--vnd-red);\n  padding: 6px 10px;\n}\n.vnd-btn-delete:hover { background: #fbd9d6; }\n\n/* ── FOOTER NOTE ──────────────────────────────────────── */\n.vnd-footer-note {\n  font-size: 12px;\n  color: var(--vnd-ink-3);\n  text-align: right;\n  margin-top: 14px;\n  font-weight: 500;\n}\n\n/* ── RESPONSIVE ───────────────────────────────────────── */\n@media (max-width: 640px) {\n  .vnd-page { padding: 20px 16px 40px; }\n  .vnd-hero { flex-direction: column; align-items: flex-start; }\n  .vnd-stats { flex-direction: column; width: 100%; }\n  .vnd-stat-divider { width: 100%; height: 1px; }\n  .vnd-table th:nth-child(1),\n  .vnd-table td:nth-child(1) { display: none; }\n  .vnd-action-btn span { display: none; }\n  .vnd-action-btn { padding: 7px 9px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
